var _rect, _polygon, _path, _polygon2, _path2, _path3, _path4, _circle, _polygon3, _path5, _path6, _path7, _ellipse, _rect2, _rect3, _rect4, _rect5, _rect6, _path8, _path9, _ellipse2, _rect7, _rect8, _rect9, _rect0, _rect1, _path0, _rect10, _rect11, _rect12, _rect13, _path1, _path10, _ellipse3, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _path11, _path12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTip3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ba655a8f-b4ad-4c33-a1da-708fab31f9a8",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 847.02014,
    height: 535.57534,
    viewBox: "0 0 847.02014 535.57534",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "reviewed_docs") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 641.02014,
    y: 515.78767,
    width: 206,
    height: 2,
    fill: "#3f3d56"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "765.971 223.569 765.971 237.359 775.623 252.527 782.518 224.948 765.971 223.569",
    fill: "#a0616a"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M941.082,283.05788l7.54033-2.153s11.76454,2.153,11.76454,15.94223,2.75783,68.94594,2.75783,68.94594l-2.75783,31.71514s4.13675,1.37892,2.75783,5.51567S959.008,416.813,957.629,415.43409s-1.37892-4.13675-1.37892-4.13675-22.0627,4.13675-20.68378,0,1.37892-13.78919,2.75784-13.78919-1.37892-41.36757-1.37892-41.36757Z",
    transform: "translate(-176.48993 -182.21233)",
    fill: "#e6e6e6"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "639.8 218.743 657.726 240.806 679.789 267.005 686.683 235.29 674.357 233.355 661.863 214.606 639.8 218.743",
    fill: "#a0616a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M861.10472,393.37139s-20.68378,11.03135-6.89459,85.493l4.13675,74.46162,2.75784,122.72377H888.6831l5.51567-121.34486,16.547-77.21945,26.19946,68.94594-9.65243,122.72378,37.2308,5.51567L976.9339,536.779l-22.0627-102.04-16.547-28.9573-3.4473-7.584Z",
    transform: "translate(-176.48993 -182.21233)",
    fill: "#2f2e41"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M865.24148,671.913l-4.13676,12.41026s-5.51567,22.06271,13.78919,19.30487S887.30418,688.46,887.30418,688.46l-1.37892-16.547Z",
    transform: "translate(-176.48993 -182.21233)",
    fill: "#2f2e41"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M928.67174,667.77624S924.535,681.56543,924.535,688.46s2.75784,9.8946,2.75784,9.8946,78.59837,5.27351,77.21945-1.62109-9.65243-9.65243-9.65243-9.65243L975.555,682.94435,961.7658,671.913l-27.57838-6.8946Z",
    transform: "translate(-176.48993 -182.21233)",
    fill: "#2f2e41"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 720.46668,
    cy: 40.17313,
    r: 26.19946,
    fill: "#a0616a"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "739.772 51.204 743.908 89.814 734.256 107.74 710.814 81.541 708.056 59.478 739.772 51.204",
    fill: "#a0616a"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M907.988,273.40545l-21.627-17.198-4.57249,6.16663-34.473,13.78919,1.37892,60.67243s1.37892,51.02,9.65243,56.53567l-3.44729,4.82622,82.04567,3.44729V364.4141l17.92594-79.9773-31.71513-17.92594-3.947-5.58274Z",
    transform: "translate(-176.48993 -182.21233)",
    fill: "#e6e6e6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M852.83121,278.92113l-2.00848-4.16072-4.88612,1.40288s-9.65243,4.13676-16.547,22.0627-26.19946,57.91459-26.19946,57.91459-5.51568,6.8946-1.37892,13.78919,8.27351,22.0627,8.27351,22.0627-4.13675-1.37892-1.37891,4.13676,2.75783,11.03135,11.03135,9.65243,24.82054-5.51567,23.44162-9.65243-2.75784-11.03135-5.51568-11.03135-6.89459-20.68378-6.89459-20.68378l2.75783-11.03136,20.68379-24.82053Z",
    transform: "translate(-176.48993 -182.21233)",
    fill: "#e6e6e6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M899.71445,203.08059s-4.13676,0-4.13676-1.37892c0,0-14.42328-.4402-20.31137,5.985s-4.50917-3.22719-4.50917-3.22719-15.1681-6.89459-2.75783-13.78919l1.37891,1.37892s2.75784-4.13676,12.41027-5.51567l-1.37892-1.37892s0-1.37892,6.8946-1.37892,24.82054-6.8946,26.19946,8.27351c0,0,11.03135-4.13676,11.03135,9.65243s-1.37892,20.68379-1.37892,20.68379-2.75784-6.8946-8.27351-2.75784S899.71445,203.08059,899.71445,203.08059Z",
    transform: "translate(-176.48993 -182.21233)",
    fill: "#2f2e41"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 106.50084,
    cy: 462.54463,
    rx: 106.50084,
    ry: 11.00509,
    fill: "#e6e6e6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 41.89033,
    y: 302.13508,
    width: 129.22102,
    height: 160.46126,
    fill: "#e6e6e6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 60.56102,
    y: 358.17372,
    width: 92.30073,
    height: 4.26003,
    fill: "#fff"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 60.56102,
    y: 373.08384,
    width: 92.30073,
    height: 4.26003,
    fill: "#fff"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 60.56102,
    y: 387.99395,
    width: 92.30073,
    height: 4.26003,
    fill: "#fff"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 60.56102,
    y: 402.90407,
    width: 92.30073,
    height: 4.26003,
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M308.34511,417.68517a25.28307,25.28307,0,1,1-3.9184-13.54383A25.35178,25.35178,0,0,1,308.34511,417.68517Z",
    transform: "translate(-176.48993 -182.21233)",
    fill: "#e6e6e6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M304.42671,404.14134l-24.9579,24.95329c-1.56861-2.42849-10.30768-13.7144-10.30768-13.7144a35.36357,35.36357,0,0,1,3.57727-3.15778l7.24672,9.66232L301.504,400.36585A25.24938,25.24938,0,0,1,304.42671,404.14134Z",
    transform: "translate(-176.48993 -182.21233)",
    fill: "#fff"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 451.11664,
    cy: 456.08848,
    rx: 106.50084,
    ry: 11.00509,
    fill: "#e6e6e6"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 386.50613,
    y: 295.67893,
    width: 129.22102,
    height: 160.46126,
    fill: "#e6e6e6"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 405.17683,
    y: 385.00197,
    width: 92.30073,
    height: 4.26003,
    fill: "#fff"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 405.17683,
    y: 399.91209,
    width: 92.30073,
    height: 4.26003,
    fill: "#fff"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 405.17683,
    y: 414.82221,
    width: 92.30073,
    height: 4.26003,
    fill: "#fff"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 405.17683,
    y: 429.73232,
    width: 92.30073,
    height: 4.26003,
    fill: "#fff"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M609.94241,535.00452H580.61658a102.56855,102.56855,0,0,1,0-34.96542h29.32583A62.91477,62.91477,0,0,0,609.94241,535.00452Z",
    transform: "translate(-176.48993 -182.21233)",
    fill: "#fff"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 445.64714,
    y: 321.10147,
    width: 53.96042,
    height: 3.55003,
    fill: "#fff"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 445.64714,
    y: 333.88157,
    width: 53.96042,
    height: 3.55003,
    fill: "#fff"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 445.64714,
    y: 346.66167,
    width: 53.96042,
    height: 3.55003,
    fill: "#fff"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 445.64714,
    y: 359.44177,
    width: 53.96042,
    height: 3.55003,
    fill: "#fff"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M652.96091,412.06114a25.28317,25.28317,0,1,1-3.9184-13.54383A25.35177,25.35177,0,0,1,652.96091,412.06114Z",
    transform: "translate(-176.48993 -182.21233)",
    fill: "#e6e6e6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M649.04251,398.51731l-24.95789,24.95328c-1.56862-2.42848-10.30769-13.71439-10.30769-13.71439a35.36455,35.36455,0,0,1,3.57727-3.15779l7.24672,9.66232,21.51892-21.51891A25.24931,25.24931,0,0,1,649.04251,398.51731Z",
    transform: "translate(-176.48993 -182.21233)",
    fill: "#fff"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 280.78106,
    cy: 522.67764,
    rx: 124.81648,
    ry: 12.8977,
    fill: "#3f3d56"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 204.22696,
    y: 337.53319,
    width: 151.444,
    height: 188.05683,
    fill: "#edd84f"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 225.86181,
    y: 377.47447,
    width: 108.17428,
    height: 4.99266,
    fill: "#fff"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 225.86181,
    y: 394.94877,
    width: 108.17428,
    height: 4.99266,
    fill: "#fff"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 225.86181,
    y: 412.42308,
    width: 108.17428,
    height: 4.99266,
    fill: "#fff"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 225.86181,
    y: 429.89739,
    width: 108.17428,
    height: 4.99266,
    fill: "#fff"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 225.86181,
    y: 447.3717,
    width: 108.17428,
    height: 4.99266,
    fill: "#fff"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 251.65722,
    y: 465.67811,
    width: 56.58347,
    height: 19.97064,
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M494.98058,438.93742a37.99362,37.99362,0,1,1-5.88828-20.35267A38.09678,38.09678,0,0,1,494.98058,438.93742Z",
    transform: "translate(-176.48993 -182.21233)",
    fill: "#edd84f"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M489.0923,418.58475l-37.50488,37.498c-2.3572-3.64934-15.48963-20.609-15.48963-20.609a53.14175,53.14175,0,0,1,5.37566-4.74528l10.88983,14.51982,32.337-32.337A37.94244,37.94244,0,0,1,489.0923,418.58475Z",
    transform: "translate(-176.48993 -182.21233)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTip3);
export default __webpack_public_path__ + "static/media/tip3.606efd498b8f98e4a1384a77b9aec988.svg";
export { ForwardRef as ReactComponent };